(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tl-buy-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tl-buy')) {
    customElements.define(
      'tl-buy',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.status = this.querySelector('.tl-buy__status');
          this.button = this.querySelector('.tl-buy__submit');
          this.form?.addEventListener('submit', (event) => this.onSubmit(event));
        }

        setStatus(message, isError) {
          if (!this.status) return;
          this.status.hidden = !message;
          this.status.textContent = message || '';
          this.status.classList.toggle('tl-buy__status--error', Boolean(isError));
        }

        async onSubmit(event) {
          const routes = typeof Theme !== 'undefined' ? Theme.routes : null;
          if (!routes?.cart_add_url) return;
          event.preventDefault();

          let events;
          try {
            events = await import('@shopify/events');
          } catch (error) {
            this.form.submit();
            return;
          }

          const { CartLinesUpdateEvent } = events;
          const formData = new FormData(this.form);
          const sectionIds = [...document.querySelectorAll('cart-items-component')]
            .map((element) => element.dataset.sectionId)
            .filter(Boolean);
          if (sectionIds.length) formData.append('sections', sectionIds.join(','));

          const quantity = Number(formData.get('quantity')) || 1;
          const deferred = CartLinesUpdateEvent.createPromise();

          this.button?.setAttribute('aria-busy', 'true');
          if (this.button) this.button.disabled = true;
          this.setStatus('');

          this.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(formData.get('id')), quantity }],
              promise: deferred.promise,
            })
          );

          const refreshCart = () =>
            fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

          let response;
          try {
            response = await fetch(routes.cart_add_url, {
              method: 'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData,
            }).then((r) => r.json());
          } catch (error) {
            deferred.reject(error);
            this.form.submit();
            return;
          }

          try {
            const cart = await refreshCart();
            const failed = Boolean(response.status);

            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'tl-buy',
                itemCount: quantity,
                productId: this.dataset.productId,
                sections: failed ? undefined : response.sections,
                didError: failed,
              },
            });

            if (failed) {
              this.setStatus(response.description || response.message || 'Could not add to cart.', true);
            } else {
              this.setStatus('Added to cart.');
              const field = this.form.querySelector('[name^="properties"]');
              if (field) field.value = '';
              const qty = this.form.querySelector('[name="quantity"]');
              if (qty) {
                qty.value = '1';
                qty.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          } catch (error) {
            deferred.reject(error);
            this.setStatus(response.status ? 'Could not add to cart.' : 'Added to cart.', Boolean(response.status));
          } finally {
            this.button?.removeAttribute('aria-busy');
            if (this.button) this.button.disabled = false;
          }
        }
      }
    );
  }

  if (!customElements.get('tl-qty')) {
    customElements.define(
      'tl-qty',
      class extends HTMLElement {
        connectedCallback() {
          const input = this.querySelector('input');
          this.querySelectorAll('[data-step]').forEach((btn) => {
            btn.addEventListener('click', () => {
              const min = Number(input.min) || 1;
              const max = Number(input.max) || 99;
              const next = (Number(input.value) || min) + Number(btn.dataset.step);
              input.value = Math.min(max, Math.max(min, next));
              input.dispatchEvent(new Event('change', { bubbles: true }));
            });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tl-price-tiers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tl-price-tiers')) {
    customElements.define(
      'tl-price-tiers',
      class extends HTMLElement {
        connectedCallback() {
          try {
            this.tiers = JSON.parse(this.dataset.tiers || '[]').sort((a, b) => a.min - b.min);
          } catch (error) {
            this.tiers = [];
          }
          this.form = document.getElementById(this.dataset.form);
          if (!this.form || !this.tiers.length) return;

          this.formatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
          this.update = this.update.bind(this);
          this.onFormEvent = () => setTimeout(this.update, 0);

          this.form.addEventListener('input', this.onFormEvent);
          this.form.addEventListener('change', this.onFormEvent);
          this.form.addEventListener('click', this.onFormEvent);

          this.querySelectorAll('.tl-tiers__row').forEach((row) => {
            row.addEventListener('click', () => this.setQuantity(Number(row.dataset.min)));
          });

          this.update();
        }

        quantityInput() {
          return (
            this.form.querySelector('[name="quantity"]') ||
            document.querySelector(`[name="quantity"][form="${this.form.id}"]`)
          );
        }

        setQuantity(value) {
          const input = this.quantityInput();
          if (!input || !value) return;

          const selector = input.closest('quantity-selector-component');
          let max = Number(input.max) || Infinity;
          if (selector && typeof selector.getEffectiveMax === 'function') {
            max = selector.getEffectiveMax() ?? Infinity;
          }
          const next = String(Math.max(1, Math.min(value, max)));

          if (selector && typeof selector.setValue === 'function') {
            selector.setValue(next);
            selector.onQuantityChange?.();
            selector.updateButtonStates?.();
          } else {
            input.value = next;
          }

          input.dispatchEvent(new Event('change', { bubbles: true }));
          this.update();
        }

        disconnectedCallback() {
          if (!this.form) return;
          this.form.removeEventListener('input', this.onFormEvent);
          this.form.removeEventListener('change', this.onFormEvent);
          this.form.removeEventListener('click', this.onFormEvent);
        }

        quantity() {
          return Math.max(1, Number(this.quantityInput()?.value) || 1);
        }

        update() {
          const qty = this.quantity();
          let active = this.tiers[0];
          for (const tier of this.tiers) if (qty >= tier.min) active = tier;

          this.querySelectorAll('.tl-tiers__row').forEach((row) => {
            const isActive = Number(row.dataset.min) === active.min;
            row.classList.toggle('is-active', isActive);
            row.setAttribute('aria-pressed', String(isActive));
          });

          const total = this.form.querySelector('[data-tl-total]');
          if (total) total.textContent = this.formatter.format((qty * active.price) / 100);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tl-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    const jumpToHash = () => {
      const id = decodeURIComponent(location.hash.slice(1));
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;
      target.scrollIntoView({ behavior: 'instant', block: 'start' });
    };

    const scheduleJump = () => {
      jumpToHash();
      setTimeout(jumpToHash, 50);
    };

    if (document.readyState === 'complete') {
      scheduleJump();
    } else {
      window.addEventListener('load', scheduleJump, { once: true });
    }

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href="#top"]');
      if (!link) return;
      event.preventDefault();
      const wrapper = document.querySelector('.page-wrapper');
      const container = wrapper && wrapper.scrollHeight > wrapper.clientHeight ? wrapper : document.scrollingElement;
      container.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
